import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import { Img, svgSprite } from '../wrappers';
import uikit from '../../project/uikit/styles';
import { t } from '../../common/components/T';
import { rankColors } from '../../project/uikit/data-variables/rank-colors';
import { LangContext } from '../../common/decorators/Language';
import { useWidgetTranslates } from '../../common/utils/utils';

const LineProgress = ({ data, compStyles }) => {
    const { translation } = useContext(LangContext) || {};
    let { have, partners } = data || {};
    const rankColor = useMemo(() => {
        if (have) {
            return rankColors[have?.sort] || rankColors[rankColors.length - 1];
        }
        return rankColors[0];
    }, [have]);

    const trans = useWidgetTranslates('userModal');

    if (!data) return null;
    return (
        <div className={compStyles.lineProgressWrap}>
            <div
                style={{
                    ...uikit.flexRow,
                    ...uikit.alignItemsCenter,
                    ...uikit.medium,
                    ...uikit.mb1
                }}
            >
                <p style={uikit.small} className={compStyles.lineProgressTitle}>
                    {data?.title}
                </p>
                <p style={{ ...uikit.medium }}>«{have?.name}»</p>
            </div>
            {Array.isArray(partners?.set) ? (
                <div className={compStyles.structuresWrapper}>
                    {partners.set.map((el, i) => (
                        <div
                            key={el}
                            style={{
                                ...uikit.flexRow,
                                ...uikit.alignItemsCenter,
                                ...(i !== 0 ? uikit.mt2 : {})
                            }}
                        >
                            <div>
                                <div
                                    style={have?.preview?.links?.preview ? {} : { marginRight: '6px' }}
                                    className={have?.preview?.links?.preview ? compStyles.rangIcon : ''}
                                >
                                    {have && have?.preview?.links?.preview ? (
                                        <Img
                                            src={have?.preview?.links?.preview}
                                            style={{
                                                width: '100%',
                                                height: '100%'
                                            }}
                                        />
                                    ) : (
                                        svgSprite('rankPlug', {
                                            width: '28px',
                                            height: '28px'
                                        })
                                    )}
                                </div>
                            </div>
                            <div style={{ flexGrow: 1 }}>
                                <div
                                    style={{
                                        ...uikit.small,
                                        ...uikit.medium,
                                        marginBottom: '3px'
                                    }}
                                >
                                    {(i === 0
                                        ? '1 ' + t('user_modal_Branch', 'ветка', 'widget', trans, 'userModal')
                                        : '2 ' + t('user_modal_Branch', 'ветка', 'widget', trans, 'userModal')) +
                                        ' ' +
                                        el +
                                        ' ' +
                                        t('of', 'из', 'all', translation) +
                                        ' ' +
                                        partners.max[i]}
                                </div>
                                <div className={compStyles.progressBarPath}>
                                    <div
                                        className={compStyles.progressBarPathDone}
                                        style={{
                                            background: rankColor.gradient,
                                            width: `${100 / (partners.max[i] / el)}%`
                                        }}
                                    />
                                </div>
                                {/*<div className={compStyles.progressBarCount}>*/}
                                {/*    <p>0</p>*/}
                                {/*    <p>{partners.max}</p>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div style={{ ...uikit.flexRow, ...uikit.alignItemsCenter }}>
                    <div>
                        <div
                            style={{
                                ...(have?.preview?.links?.preview ? {} : { 'margin-right': '6px' })
                            }}
                            className={have?.preview?.links?.preview ? compStyles.rangIcon : ''}
                        >
                            {have && have?.preview?.links?.preview ? (
                                <Img src={have?.preview?.links?.preview} style={{ width: '100%', height: '100%' }} />
                            ) : (
                                svgSprite('rankPlug', {
                                    width: '28px',
                                    height: '28px'
                                })
                            )}
                        </div>
                    </div>
                    <div style={{ flexGrow: 1 }}>
                        <div
                            style={{
                                ...uikit.small,
                                ...uikit.medium,
                                marginBottom: '3px'
                            }}
                        >
                            {partners.set + ' ' + t('of', 'из', 'all', translation) + ' ' + partners.max}
                        </div>
                        <div className={compStyles.progressBarPath}>
                            <div
                                className={compStyles.progressBarPathDone}
                                style={{
                                    background: rankColor.gradient,
                                    width: `${100 / (partners.max / partners.set)}%`
                                }}
                            />
                        </div>
                        {/*<div className={compStyles.progressBarCount}>*/}
                        {/*    <p>0</p>*/}
                        {/*    <p>{partners.max}</p>*/}
                        {/*</div>*/}
                    </div>
                </div>
            )}
        </div>
    );
};

LineProgress.propTypes = {
    styles: PropTypes.object,
    data: PropTypes.object
};
export default LineProgress;
